module.exports = __webpack_public_path__ + "media/images/partners/lmr-97c70c80bd55e3883d5ccd8802d66171.png";